import { useEffect } from "react";

import { offHistory, onHistory } from "../window/history";

function cleanUrl(): void {
  // strip trailing "?" left by bad history updates
  // the ONLY place that reflects a trailing "?" is `location.href`
  // (no part of react-router's data reflects a trailing "?", nor
  // any other property of the window.location object)
  if (window.location.href.endsWith("?")) {
    window.history.replaceState(
      window.history.state,
      "",
      window.location.pathname, // will not include "?"
    );

    // shame the developer
    console.warn(
      "Cleaning trailing question mark from URL...fix your history code",
    );
  }
}

/**
 * Hook that monitors the URL for trailing question marks (with no search params)
 * and clears them by redirecting to the clean URL.
 */
const useUrlCleaner = (): void => {
  // on initial load
  useEffect(() => {
    cleanUrl();
  }, []);

  // on every url change
  useEffect(() => {
    onHistory(cleanUrl);
    return () => offHistory(cleanUrl);
  }, []);
};

/**
 * A component that will reactively clean the URL.
 */
export function UrlCleaner(): null {
  useUrlCleaner();
  return null;
}
